/**
 * RSRP / RSRQ / SINR sampled ACROSS a test window (#252 SC-6), not just the
 * post-test snapshot. Data = `executions/{id}.signalSamples`, fed by the
 * edge's radio sampler while a managed modem is allocated.
 */
import React, { useMemo } from 'react';
import { LineChart } from '@/components/charts/LineChart';
import { Card } from '@/components/ui';

export interface SignalSampleLike { t: number; rsrp?: number | null; rsrq?: number | null; sinr?: number | null; tech?: string | null; band?: string | null; pci?: number | null }

export const SignalSamplesChart: React.FC<{ samples: SignalSampleLike[] | undefined | null }> = ({ samples }) => {
  const data = useMemo(() => (samples || []).filter((s) => typeof s.t === 'number').map((s) => ({
    t: `${Math.round(s.t / 1000)}s`, rsrp: s.rsrp ?? null, rsrq: s.rsrq ?? null, sinr: s.sinr ?? null,
  })), [samples]);
  if (data.length < 2) return null;
  const last = (samples || [])[(samples || []).length - 1];
  return (
    <Card padding="lg">
      <div className="text-caption text-muted-foreground uppercase mb-1">Radio conditions during the test</div>
      <p className="text-xs text-muted-foreground mb-3">
        {data.length} samples{last?.tech ? ` · ${last.tech}` : ''}{last?.band ? ` · ${last.band}` : ''}{last?.pci != null ? ` · PCI ${last.pci}` : ''}
      </p>
      <LineChart
        data={data}
        xAxisKey="t"
        height={220}
        lines={[
          { dataKey: 'rsrp', name: 'RSRP (dBm)' },
          { dataKey: 'rsrq', name: 'RSRQ (dB)' },
          { dataKey: 'sinr', name: 'SINR (dB)' },
        ]}
      />
    </Card>
  );
};
